import { Link } from "@tanstack/react-router";
import { Facebook, Mail, MapPin, Phone, Twitter, Youtube } from "lucide-react";

import { footerNav, site } from "@/data/site";

const socialIcons = { Facebook, X: Twitter, YouTube: Youtube } as const;

export function Footer() {
  return (
    <footer className="bg-muted">
      <div className="container-site grid gap-12 py-16 md:grid-cols-3">
        <div className="flex flex-col gap-5">
          <img src={site.logo} alt={site.name} className="h-14 w-auto brightness-0" />
          <p className="text-base">{site.tagline}</p>
          <div className="flex gap-3">
            {site.socials.map((social) => {
              const Icon = socialIcons[social.label as keyof typeof socialIcons];
              return (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  target="_blank"
                  rel="noreferrer"
                  className="flex h-11 w-11 items-center justify-center rounded-full bg-navy text-white transition-colors hover:bg-brand hover:text-brand-foreground"
                >
                  <Icon className="h-4 w-4" aria-hidden />
                </a>
              );
            })}
          </div>
        </div>

        <nav aria-label="Footer">
          <h2 className="text-lg text-navy">Explore</h2>
          <ul className="mt-4 flex flex-col gap-0">
            {footerNav.map((item) => (
              <li key={item.label}>
                <Link
                  to={item.to}
                  className="inline-flex min-h-11 items-center text-base transition-colors hover:text-brand-foreground"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h2 className="text-lg text-navy">Get in touch</h2>
          <ul className="mt-4 flex flex-col gap-3 text-base">
            <li className="flex gap-3">
              <MapPin className="mt-1 h-4 w-4 shrink-0 text-brand-foreground" aria-hidden />
              <a
                href={site.addressUrl}
                target="_blank"
                rel="noreferrer"
                className="hover:text-brand-foreground"
              >
                {site.address}
              </a>
            </li>
            <li className="flex gap-3">
              <Phone className="mt-1 h-4 w-4 shrink-0 text-brand-foreground" aria-hidden />
              <a href={site.phoneHref} className="hover:text-brand-foreground">
                {site.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <Mail className="mt-1 h-4 w-4 shrink-0 text-brand-foreground" aria-hidden />
              <a href={`mailto:${site.email}`} className="hover:text-brand-foreground">
                {site.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-site flex flex-wrap items-center justify-between gap-2 py-6 text-sm">
          <p>
            © {new Date().getFullYear()} {site.name}. All rights reserved.
          </p>
          <p>
            Site by{" "}
            <a
              href={site.credit.href}
              target="_blank"
              rel="noreferrer"
              className="hover:text-brand-foreground"
            >
              {site.credit.label}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
